import React from 'react';

/**
 * WhatsApp-style delete options for selected messages.
 * Props:
 *  - open
 *  - canDeleteForEveryone (only when all selected are own + within 2 days)
 *  - onEveryone, onOnlyMe, onCancel
 */
const DeleteMessageModal = ({ open, canDeleteForEveryone, onEveryone, onOnlyMe, onCancel, count }) => {
    if (!open) return null;

    return (
        <div className="chat-modal-backdrop" role="dialog" aria-modal="true">
            <div className="chat-modal">
                <h4>Delete message{count > 1 ? 's' : ''}?</h4>
                <p className="chat-modal-sub">
                    {count > 1 ? `${count} messages selected` : '1 message selected'}
                </p>
                <div className="chat-modal-actions">
                    {canDeleteForEveryone ? (
                        <button type="button" className="chat-modal-btn danger" onClick={onEveryone}>
                            Delete for everyone
                        </button>
                    ) : null}
                    <button type="button" className="chat-modal-btn" onClick={onOnlyMe}>
                        Only for me
                    </button>
                    <button type="button" className="chat-modal-btn muted" onClick={onCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteMessageModal;
